<template>
  <div class="cb-body__wrap" v-if="agreements">
    <div class="cb-body__content">
      <div class="cb-section cb-guarantee">
        <div class="cb-note cb-note--left cb-note--align cb-note--fw cb-note--overflow">
          <div class="cb-note__content">
            <div
              class="cb-note__p"
              v-for="(value, key) in agreements"
              v-cb-html="sanitizeTags(getAgreement(value))"
              v-bind:key="key"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  mounted() {},
  computed: {
    ...mapGetters(["pm_list"]),
    scheme() {
      return this.$route.query.scheme;
    },
    pm() {
      return this.pm_list.filter(
        pm => pm.gateway_name == "EZIDEBIT" && pm.configuration && pm.configuration.scheme == this.scheme
      )[0];
    },
    pmConfiguration() {
      return this.pm && this.pm.configuration;
    },
    agreements() {
      // Show all agreements on guarantee page (including TERMS_AND_CONDITION)
      if (this.pmConfiguration) {
        let agreement_list = this.pmConfiguration.agreement_list;
        return agreement_list && agreement_list.length > 1
          ? agreement_list.slice(1)
          : [];
      }
    }
  },
  methods: {
    sanitizeTags(content) {
      return {
        text: content,
        tags: ["b", "i", "a", "section", "br", "li", "h3", "div", "p", "strong", "ol", "ul", "h1", "h2", "h4"]
      };
    },
    getAgreement(agreement) {
      // Ezidebit agreements are plain HTML strings, not objects
      return agreement;
    }
  }
};
</script>

<style>
.cb-guarantee li {
  padding-left: 12px;
}
.cb-guarantee .cb-note--overflow {
  max-height: 400px;
  overflow: scroll;
  margin-bottom: 32px;
}
.cb-guarantee h3 {
  font-weight: bold;
  margin-bottom: 6px;
}
.cb-guarantee section {
  margin-bottom: 20px;
}
.cb-guarantee div {
  margin-bottom: 8px;
}
</style>

